.csatRating {
  margin-bottom: 16px;
}
